<template>
        <div id="header-container">
            <div class="bg-image">
            </div>
            <div class="animate__animated animate__zoomIn">
                <div style="margin-top: 0px; margin-left:18%; padding-bottom: 20px;" class="banner-title text-white">Welcome to FabricFour Learning</div>
                <!--<div class="banner-subtitle text-white">Let's manage some content</div>-->
            </div>
            <div class="wrap-inconbox-benefit">
                <div class="title-section">
                    <div class="flat-title small text-white" style="margin-left: 18%; font-size: 24px">
                        Custom-branded. Cost-effective. Mindfully designed.
                    </div>
                </div>
                <div class="iconbox-benefit iconbox-benefit-style1">
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-6 benefit-saica">
                            <div class="themesflat-content-box ml-auto" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/courses">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/accessible-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Courses</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        <div class="col-6 benefit-saica">
                            <div class="themesflat-content-box" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/users">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/progress-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Users</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        
                        
                    </div>
                    <div class="row" style="padding-bottom: 20px;">
                        <div class="col-6 benefit-saica">
                            <div class="themesflat-content-box ml-auto" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/payments">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/book-solid-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Payments</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>

                        <div class="col-6 benefit-saica">
                            <div class="themesflat-content-box" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/coupons">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/simplicity-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Coupons</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        
                    </div>
                    <div class="row">
                        <div class="col-6 benefit-saica" v-show="userRole == 'admin'">
                            <div class="themesflat-content-box ml-auto" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/sites">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/award-solid-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Sites</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                        
                        <div class="col-6 benefit-saica" v-show="userRole == 'admin'">
                            <div class="themesflat-content-box" data-padding="0% 4% 0% 0%" data-sdesktoppadding="0% 0% 0% 0%" data-ssdesktoppadding="0% 0% 0% 0%" data-mobipadding="0% 0% 0% 0%" data-smobipadding="0% 0% 0% 0%">
                                <router-link to="/admin/coursePackages">
                                    <div class="iconbox bg-tr-sea-blue">
                                        <div class="iconbox-icon">
                                            <img src="/wwwroot/images/home/centralized-dblue.png" class="benefit-icon" alt="images">
                                        </div>
                                        <div class="iconbox-content img-one">
                                            <h3 style="color: white">Course Packages</h3>
                                            <p></p>
                                        </div>
                                    </div>
                                </router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
</template>

<style>
    .bg-image{
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        background: linear-gradient(#313131,rgba(18,111,154,.87)),url(/wwwroot/images/home/header1.jpg) !important;
        background-blend-mode: multiply;
        background-size: cover;
        height: 800px;
    }

    #header-container {
        position: absolute;
        left: 0;
        right: 0;
        top: 85px;
        bottom: 0;
        background-color: #030936;
        padding-top: 100px;
    }

    .flat-benefit.style1 {
        background-size: cover;
        padding: 113px 0 47px 0;
        background-color: #343a40;
        background-image: none;
    }

    .iconbox-benefit-style1 .iconbox {
        margin-bottom: 0px;
    }

    .iconbox-content h3 {
        font-size: 20px;
    }

    .iconbox {
        background-color: rgba(66, 193, 196, 0.5);
        padding: 20px 10px;
        border: 1px solid #282D69;
        border-radius: 10px;
        box-shadow: 0 8px 6px -6px black;
        height: 150px;
        max-width: 500px;
    }

    .iconbox-icon{
        margin-top: 18px;
    }

    .themesflat-content-box{
        max-width: 500px;
    }

    .themesflat-content-box a:hover {
        text-decoration: none;
    }

    .benefit-icon {
        max-width: 40px;
    }

    .banner-container {
        margin-left: 10%;
        padding-top: 20px;
    }

    .banner-title {
        font-size: 45px;
        font-weight: 700;
        margin-right: 80px;
        margin-top: 140px;
    }

    .banner-subtitle {
        margin-top: 30px;
        font-size: 24px;
        font-weight: 700;
    }

    .banner-contact {
        margin-top: 2.5vw;
        font-size: 2vw !important;
    }

    .wrap-inconbox-benefit {
        padding-left: 20px;
        padding-right: 20px;
    }
</style>
<script>


    export default {
        name: 'Home',
        props: {

        },
        data() {
            return {
            }
        },
        computed: {
            userRole() {
                if (this.$store.state.user) {
                    var roles = this.$store.state.user.roles;
                    if (roles) {
                        return roles[0];
                    }
                    return '';
                }
            }
        },
        async mounted() {

            this.$store.commit("breadCrumbs", null);
        }
    }

</script>
